import gql from 'graphql-tag';

export default class PostFragments {
  static post = gql`
    fragment postFragment on Post {
      id
      participantId
      text
      seenBy
      media {
        ... on PostMediaImage {
          type
          imageId
        }
        ... on PostMediaVideo {
          type
          videoId
        }
      }
      createdAt
      updatedAt
    }
  `;
}
